import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, REGISTER } from '../utills/ApplicationRouting';
import toast, { Toaster } from "react-hot-toast";
import { IconButton, InputAdornment } from '@mui/material';
import CommonContainer from "../components/CommonContainer";
import { Visibility, VisibilityOff } from '@mui/icons-material';
function Signup() {
  const { register, handleSubmit, control, formState: { errors }, getValues, setError, clearErrors } = useForm();
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (data) => {
    setIsLoading(true)
    const postData = {
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      contact: data.contact,
      address: data.address,
      city: data.city,
      state: data.state,
      country: data.country,
      password: data.password,
      confirmPassword: data.confirmPassword,
      zipCode: data.zipcode,
    };


    // return;
    axios
      .post(`${BASE_URL}${REGISTER}`, postData)
      .then((response) => {
        console.log(response);

        if (response.status === 200) {
          console.log("success");
          toast.success(response.data);
          setIsLoading(false)
          // reset();
          setTimeout(() => {
            navigate("/login");
          }, 3000);

        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.data) {
          const errors = error.response.data; 
          if (typeof errors === "object") {
         
            Object.keys(errors).forEach((key) => {
              console.log(`${errors[key]}`); 
              toast.error(`${errors[key]}`); 
            });
          } else {
            toast.error(errors); 
          }
        } 
      });
  };

  const alphabetValidation = /^[A-Za-z]+$/;
  const zipcodeValidation = /^[0-9]{5,6}$/; // For 5 or 6-digit zip codes

  return (
    <>
      <Toaster />

      <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <div className="w-full max-w-lg bg-white rounded-xl shadow-lg p-8">
       <Typography
  variant="h5"
  align="center"
  className="block w-full font-bold mb-6"
>
  Sign Up
</Typography>
          <br></br>


          <form className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" onSubmit={handleSubmit(onSubmit)}>

            <Controller
              name="firstName"
              control={control}
              defaultValue=""
              rules={{
                required: 'First name is required',
                pattern: {
                  value: /^[a-zA-Z ]+(?: [a-zA-Z ]+)*$/,
                  message: 'Please provide valid first name',
                },
                maxLength: {
                  value: 60,
                  message: 'Please provide a maximum of 60 characters',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.trimStart(); // Trim only leading whitespace
                    field.onChange(value);

                    // Manually set error if the value is empty or null after trimming, and avoid error for valid input
                    if (value.trim() === '' || value === null) {
                      setError('firstName', {
                        type: 'manual',
                        message: 'Please provide a valid First Name',
                      });
                    } else {
                      clearErrors('firstName'); // Clear the error when a valid input is provided
                    }
                  }}
                  label={
                    <span>
                      First Name <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                />
              )}
            />

            <Controller
              name="lastName"
              control={control}
              defaultValue=""
              rules={{
                required: 'Last name is required',
                pattern: {
                  value: /^[a-zA-Z ]+(?: [a-zA-Z ]+)*$/,
                  message: 'Please provide a valid Last Name',
                },
                maxLength: {
                  value: 60,
                  message: 'Please provide a maximum of 60 characters',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.trimStart(); // Trim only leading whitespace
                    field.onChange(value);

                    // Manually set error if the value is empty or null after trimming, and avoid error for valid input
                    if (value.trim() === '' || value === null) {
                      setError('lastName', {
                        type: 'manual',
                        message: 'Please provide a valid Last Name',
                      });
                    } else {
                      clearErrors('lastName'); // Clear the error when a valid input is provided
                    }
                  }}
                  label={
                    <span>
                      Last Name <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                />
              )}
            />





            {/* Email */}
            <Controller
              name="email"
              control={control}
              defaultValue=""
              rules={{
                required: 'Email is required',
                pattern: {
                  // value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
                  value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
                  message: 'Please enter a valid email address',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <span>
                      Email <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              )}
            />

            {/* Contact */}
            <Controller
              name="contact"
              control={control}
              defaultValue=""
              rules={{
                required: 'Contact Number is required',
                pattern: {
                  value: /^\d{10}$/,
                  message: 'Please enter a valid contact number',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <span>
                      Contact <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.contact}
                  helperText={errors.contact?.message}
                />
              )}
            />

            <Controller
              name="address"
              control={control}
              defaultValue=""
              rules={{
                required: 'Address is required',
                maxLength: {
                  value: 250,
                  message: 'Please provide a maximum of 250 characters only',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.trimStart(); // Trim only leading whitespace
                    field.onChange(value);

                    // Manually set error if the value is empty or null after trimming, and avoid error for valid input
                    if (value.trim() === '' || value === null) {
                      setError('address', {
                        type: 'manual',
                        message: 'Address is required',
                      });
                    } else {
                      clearErrors('address'); // Clear the error when a valid input is provided
                    }
                  }}
                  label={
                    <span>
                      Address <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.address}
                  helperText={errors.address?.message}
                />
              )}
            />

            <Controller
              name="city"
              control={control}
              defaultValue=""
              rules={{
                required: 'City is required',
                pattern: {
                  value: /^[a-zA-Z ]*$/, // Allow only letters and spaces
                  message: 'Please provide valid city',
                },
                maxLength: {
                  value: 120,
                  message: 'Please provide a maximum of 120 characters',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.trimStart(); // Trim only leading whitespace
                    field.onChange(value);

                    // Manually set error if the value is empty or null after trimming, and avoid error for valid input
                    if (value.trim() === '' || value === null) {
                      setError('city', {
                        type: 'manual',
                        message: 'City is required',
                      });
                    } else {
                      clearErrors('city'); // Clear the error when a valid input is provided
                    }
                  }}
                  label={
                    <span>
                      City <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.city}
                  helperText={errors.city?.message}
                />
              )}
            />

            <Controller
              name="state"
              control={control}
              defaultValue=""
              rules={{
                required: 'State is required',
                pattern: {
                  value: /^[a-zA-Z ]*$/, // Allow only letters and spaces
                  message: 'Please provide valid state',
                },
                maxLength: {
                  value: 120,
                  message: 'Please provide a maximum of 120 characters',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.trimStart(); // Trim only leading whitespace
                    field.onChange(value);

                    // Manually set error if the value is empty or null after trimming, and avoid error for valid input
                    if (value.trim() === '' || value === null) {
                      setError('state', {
                        type: 'manual',
                        message: 'State is required',
                      });
                    } else {
                      clearErrors('state'); // Clear the error when a valid input is provided
                    }
                  }}
                  label={
                    <span>
                      State <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.state}
                  helperText={errors.state?.message}
                />
              )}
            />
            <Controller
              name="country"
              control={control}
              defaultValue=""
              rules={{
                required: 'Country is required',
                pattern: {
                  value: /^[a-zA-Z ]*$/, // Allow only letters and spaces
                  message: 'Please provide valid country',
                },
                maxLength: {
                  value: 120,
                  message: 'Please provide a maximum of 120 characters',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.trimStart(); // Trim only leading whitespace
                    field.onChange(value);

                    // Manually set error if the value is empty or null after trimming, and avoid error for valid input
                    if (value.trim() === '' || value === null) {
                      setError('country', {
                        type: 'manual',
                        message: 'Country is required',
                      });
                    } else {
                      clearErrors('country'); // Clear the error when a valid input is provided
                    }
                  }}
                  label={
                    <span>
                      Country <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.country}
                  helperText={errors.country?.message}
                />
              )}
            />

            <Controller
              name="password"
              control={control}
              defaultValue=""
              rules={{
                required: 'Password is required',
                minLength: { value: 8, message: 'Password must be at least 8 characters long' },
                maxLength: { value: 120, message: 'Password cannot exceed 120 characters' },
                pattern: {
                  value:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+:";'.,/?><|`~=])[A-Za-z\d!@#$%^&*()_+:;'.,/?><|"`~=]{8,128}$/,
                  message:
                    'Password must contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character.Please avoid using the following symbols in your password: [ ] { } \\ ',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <span>
                      Password <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  type={showPassword ? 'text' : 'password'}
                  variant="outlined"
                  fullWidth
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />

            <Controller
              name="confirmPassword"
              control={control}
              defaultValue=""
              rules={{
                required: 'Please confirm your password',
                minLength: { value: 8, message: 'Password must be at least 8 characters long' },
                maxLength: { value: 128, message: 'Password cannot exceed 128 characters' },
                pattern: {
                  value:/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+:";'.,/?><|`~=])[A-Za-z\d!@#$%^&*()_+:;'.,/?><|"`~=]{8,128}$/,
                  message:
                    'Password must contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character.Please avoid using the following symbols in your password: [ ] { } \\ ',
                },
                validate: {
                  matchesPassword: (value) =>
                    value === getValues('password') || 'Passwords do not match',
                },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <span>
                      Confirm Password <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  type={showConfirmPassword ? 'text' : 'password'}
                  variant="outlined"
                  fullWidth
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword?.message}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />

            <Controller
              name="zipcode"
              control={control}
              defaultValue=""
              rules={{
                required: 'Zipcode is required',
                pattern: {
                  value: zipcodeValidation,
                  message: 'Please provide valid zipcode',
                },
                minLength: { value: 5, message: 'Please provide a minimum of 5 characters.' },
                maxLength: { value: 6, message: 'Please provide a maximum of 6 characters' },
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label={
                    <span>
                      Zipcode <span style={{ color: 'red' }}>*</span>
                    </span>
                  }
                  variant="outlined"
                  fullWidth
                  error={!!errors.zipcode}
                  helperText={errors.zipcode?.message}
                />
              )}
            />
            <div className="md:col-span-2">
             <Button
  type="submit"
  variant="contained"
  fullWidth
  sx={{
    backgroundColor: "#153E75",
    color: "#fff",
    textTransform: "uppercase",
    fontSize: "0.875rem",
    fontWeight: 600,
    py: 1,
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  }}
>
  Sign Up
</Button>
<div className="mt-6 text-center">
  <Typography variant="body2">
    Already have an account?{" "}
    <span
      onClick={() => navigate("/login")}
      className="text-[#153E75] hover:text-[#1E88E5] font-semibold cursor-pointer"
    >
      Sign In
    </span>
  </Typography>
</div>
            </div>
          </form>
        </div>
      </div>
 </CommonContainer>
</div>
    </>);

}

export default Signup;
